var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Download"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15 10.5H13.3281L11.8281 12H15C15.2757 12 15.5 12.2243 15.5 12.5V15C15.5 15.2757 15.2757 15.5 15 15.5H3C2.72431 15.5 2.5 15.2757 2.5 15V12.5C2.5 12.225 2.72438 12 3 12H6.17188L4.67188 10.5H3C1.89531 10.5 1 11.3953 1 12.5V15C1 16.1047 1.89531 17 3 17H15C16.1047 17 17 16.1047 17 15V12.5C17 11.3969 16.1031 10.5 15 10.5ZM14.5 13.75C14.5 13.3356 14.1641 13 13.75 13C13.3359 13 13 13.3344 13 13.75C13 14.1641 13.3359 14.5 13.75 14.5C14.1641 14.5 14.5 14.1656 14.5 13.75ZM8.46875 12.5031C8.61562 12.6781 8.80625 12.75 9 12.75C9.19375 12.75 9.38375 12.6768 9.53031 12.5303L13.7803 8.28028C14.0733 7.98731 14.0733 7.51278 13.7803 7.21966C13.4873 6.92653 13.0128 6.92669 12.7197 7.21966L9.75 10.1906V1.75C9.75 1.33594 9.41562 1 9 1C8.58437 1 8.25 1.33594 8.25 1.75V10.1906L5.25313 7.21875C4.96016 6.92578 4.48563 6.92578 4.1925 7.21875C3.89938 7.51172 3.89953 7.98625 4.1925 8.27938L8.46875 12.5031Z",
    fill: "#007BC3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.e3b372fe16047dfe00d4d086332ac640.svg";
export { ForwardRef as ReactComponent };